import logo from "./logo.svg";
import "./App.css";

import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import PrivacyPolicyPage from "./PrivacyPolicyPage";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/privacy">
          <PrivacyPolicyPage />
        </Route>
        <Route path="/">
          <PrivacyPolicyPage />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
